import type {
  NamedPathLookupAdvancedOptions,
  PathLookupAdvancedOptions,
} from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface UpdateAdvancedOptionsCommand {
  originalAdvancedOptions: NamedPathLookupAdvancedOptions;
  newAdvancedOptions: PathLookupAdvancedOptions;
}

export const updateAdvancedOptions: GraphCommandFactory<
  UpdateAdvancedOptionsCommand
> = (cmdContext) => async (command) => {
  try {
    const newAdvancedOptions = await cmdContext.api.request({
      url: `/graphs/path-lookup/advanced-options/${command.originalAdvancedOptions.id}`,
      method: 'PUT',
      data: {
        name: command.originalAdvancedOptions.name,
        ...command.newAdvancedOptions,
      },
    });

    cmdContext.updateState((draft) => {
      draft.pathlookup.advancedOptions = draft.pathlookup.advancedOptions.map(
        (a) => {
          if (a.id === newAdvancedOptions.id) {
            return newAdvancedOptions;
          }
          return a;
        },
      );
    });

    cmdContext.showNotification({
      type: 'success',
      message:
        cmdContext.msg.canvasGraph.graphSidePanel.pathlookup.advancedOptions
          .saved,
    });
  } catch (e) {
    cmdContext.updateState((draft) => {
      draft.loading = 'ERROR';
    });
    cmdContext.logError(e, 'GRAPH');
  }
};
